import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '../ui/Card';
import apiClient from '../../utils/api';

const CoachingInsightCard = () => {
  const [insight, setInsight] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchInsight = async () => {
      try {
        const tzOffset = Math.round(-new Date().getTimezoneOffset() / 60);
        const res = await apiClient.get(`/api/coaching/insight?tz_offset=${tzOffset}`);
        setInsight(res.data);
      } catch (err) {
        console.error('Failed to load coaching insight:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };
    fetchInsight();
  }, []);

  const timeAgo = (isoString) => {
    const diff = Date.now() - new Date(isoString).getTime();
    const mins = Math.floor(diff / 60000);
    if (mins < 1) return 'Just now';
    if (mins < 60) return `${mins}m ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours}h ago`;
    const days = Math.floor(hours / 24);
    return `${days}d ago`;
  };

  if (error) {
    return (
      <Card>
        <CardContent className="p-6">
          <p className="text-sm text-gray-600 dark:text-gray-300">
            Unable to load coaching insights right now.
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="border-l-4 border-l-primary-500">
      <CardContent className="p-6">
        {loading ? (
          <div className="animate-pulse space-y-3">
            <div className="flex items-center gap-2">
              <div className="h-5 w-5 bg-gray-200 dark:bg-gray-700 rounded" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-28" />
            </div>
            <div className="space-y-2">
              <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-full" />
              <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-5/6" />
              <div className="h-3 bg-gray-200 dark:bg-gray-700 rounded w-4/6" />
            </div>
          </div>
        ) : (
          <>
            <div className="flex items-center gap-2 mb-3">
              <svg className="w-5 h-5 text-primary-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
              <h3 className="text-lg font-bold text-gray-900 dark:text-white">Health Coach</h3>
            </div>
            <p className="text-base text-gray-700 dark:text-gray-200 leading-relaxed">
              {insight?.insight_text}
            </p>
            {insight?.generated_at && (
              <p className="mt-3 text-sm text-gray-600 dark:text-gray-300">
                Updated {timeAgo(insight.generated_at)}
              </p>
            )}
          </>
        )}
      </CardContent>
    </Card>
  );
};

export default CoachingInsightCard;
